import React from 'react'

function FloorDisOut() {
  return (
    <embed src="\pdfs\E1.3.6_Q-B-DN200_Floor_displacement_outlet_05.2015_kr.pdf" width="100%" height="2100px" />
  )
}

export default FloorDisOut